export interface VhqExportRow {
  company_id: number
  name: string
  ico: string | null
  company_type: number | null
  sidlo_typ_balika: string | null
  sidlo_zaplatene_do: string | null
  owner_name: string | null
  active_on_address: boolean | number | null
  marked_mailbox: boolean | number | null
  custom_note: string | null
}

export const VHQ_EXPORT_HEADERS = [
  'ID Subjektu',
  'Subjekt',
  'IČO',
  'Adresa',
  'Balík',
  'Zaplatené do',
  'Stav',
  'Aktívne na adrese',
  'Označená schránka',
  'Poznámka',
] as const

export function getVhqStatus(row: Pick<VhqExportRow, 'sidlo_zaplatene_do'>): string {
  if (!row.sidlo_zaplatene_do) return '—'
  return new Date(row.sidlo_zaplatene_do) >= new Date() ? 'Aktívne' : 'Expirované'
}

export function formatVhqDate(date: string | null): string {
  if (!date) return '—'
  return new Date(date).toLocaleDateString('sk-SK')
}

export function yesNoUnknown(value: boolean | number | null): string {
  if (value == null) return '—'
  return value ? 'Áno' : 'Nie'
}

export function mapVhqRowsToSheet(rows: VhqExportRow[]): (string | number)[][] {
  const sheet: (string | number)[][] = [[...VHQ_EXPORT_HEADERS]]
  for (const row of rows) {
    sheet.push([
      row.company_id,
      row.name,
      row.ico || '—',
      row.owner_name || '—',
      row.sidlo_typ_balika || '—',
      formatVhqDate(row.sidlo_zaplatene_do),
      getVhqStatus(row),
      yesNoUnknown(row.active_on_address),
      yesNoUnknown(row.marked_mailbox),
      row.custom_note || '—',
    ])
  }
  return sheet
}